import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { ol, ul, li, small, medium, large, a } from '~/styles/typography';

import { formatText } from '~/utilities/helpers';

const fontSizes = {
    small,
    medium,
    large
};

const Ol = styled.ol`
    ${ol};
    margin-bottom: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        margin-bottom: 45px;
    }

    li {
        ${li};
        ${({ fontSize }) =>
            fontSize ? fontSizes[fontSize] : fontSizes.medium};
    }

    a {
        ${a};
    }
`;

const Ul = styled.ul`
    ${ul};
    margin-bottom: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        margin-bottom: 45px;
    }

    li {
        ${li};
        ${({ fontSize }) =>
            fontSize ? fontSizes[fontSize] : fontSizes.medium};
    }

    a {
        ${a};
    }
`;

const List = ({
    items,
    anchor = '',
    ordered,
    className = '',
    fontSize = ''
}) =>
    ordered ? (
        <Ol {...{ className, fontSize }} {...(anchor ? { id: anchor } : {})}>
            {items.map(({ attributes: { content }, order }) => (
                <li key={order.toString()}>{formatText(content)}</li>
            ))}
        </Ol>
    ) : (
        <Ul {...(anchor ? { id: anchor } : {})} {...{ className, fontSize }}>
            {items.map(({ attributes: { content }, order }) => (
                <li key={order.toString()}>{formatText(content)}</li>
            ))}
        </Ul>
    );

List.propTypes = {
    anchor: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            attributes: PropTypes.shape({
                content: PropTypes.string.isRequired
            }).isRequired,
            order: PropTypes.number.isRequired
        }).isRequired
    ).isRequired,
    ordered: PropTypes.bool.isRequired,
    className: PropTypes.string,
    fontSize: PropTypes.string
};

export default List;
